<template>
  <!-- Tela de seleção de usuários -->
   <div>
  <v-container v-if="!usuarioSelecionado" grid-list-xl fluid>
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-card outlined>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-account-multiple</v-icon>
            Selecione um Paciente
          </v-card-title>

          <v-card-text class="pa-4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar paciente por nome, ID OS ou empresa"
              single-line
              hide-details
              outlined
              class="mb-4"
              clearable
            ></v-text-field>

            <v-progress-linear
              v-if="loadingUsuarios"
              indeterminate
              color="primary"
              class="mb-4"
            ></v-progress-linear>

            <v-alert
              v-if="!loadingUsuarios && usuariosFiltrados.length === 0"
              type="info"
              outlined
            >
              Nenhum paciente encontrado.
            </v-alert>
            <v-list v-if="!loadingUsuarios && usuariosFiltrados.length > 0" three-line>
              <v-list-item
                v-for="usuario in usuariosFiltrados"
                :key="usuario.idexamesos"
                @click="selecionarUsuario(usuario)"
                class="mb-2"
                :class="{'selected-user': usuarioSelecionado && usuarioSelecionado.idexamesos === usuario.idexamesos}"
              >
                <v-list-item-avatar color="primary" size="50">
                  <span class="white--text text-h6">{{ getIniciais(usuario.paciente) }}</span>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="text-h6 primary--text">
                    {{ usuario.paciente }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-body-1">
                    <v-icon small>pause</v-icon>
                       <strong  class="orange--text text--lighten-1" v-if="usuario.status == 'Aguardando'"> {{ usuario.status }} </strong>
                       <strong  class="blue--text text--lighten-1" v-else> {{ usuario.status }} </strong>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-body-2">
                    <v-icon small>mdi-office-building</v-icon>
                    Empresa: {{ usuario.empresa_cliente }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-body-2">
                    <v-icon small>mdi-calendar</v-icon>
                    Data: {{ usuario.datalanca }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-icon color="primary">mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

  <!-- Conteúdo principal (após seleção) -->
   <div v-else>

    <!-- Seu conteúdo original aqui -->
      <v-row no-gutters class="mt-5">
        <!-- Menu lateral esquerdo -->
        <v-col cols="2"
        sm="2"
        md="2" class="mr-1 ml-4">
          <v-card outlined class="ml-2">
            <v-sheet class="rounded-lg">
              <v-card flat class="rounded-lg mt-3">
                <v-layout row class="align-center pt-4 justify-center">
                  <v-btn
                    color="orange"
                    @click="voltarParaLista"
                    outlined
                    small
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    voltar
                  </v-btn>
                </v-layout>
              </v-card>
              <v-divider class="my-2"></v-divider>
              <v-list dense>
                <v-list-item-group active-class="border" v-model="mItem" :color="items[mItem].color">
                  <v-list-item v-for="(item, i) in items" :key="i" link
                      :disabled="item.id == 7 && item.badge == 0 || item.disabled">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-show="item.badge">
                      <v-avatar right size="20" class="amber lighten-2">
                        {{ item.badge }}
                      </v-avatar>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <v-divider />
              <div class="pb-2">
                <v-list dense>

                  <v-list-item link @click="liberarBloquearAso(true)">
                    <v-list-item-icon>
                      <v-icon color="green">check_circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        LIBERAR
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                   <v-list-item link @click="liberarBloquearAso(false)">
                    <v-list-item-icon>
                      <v-icon color="red">block</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        BLOQUEAR
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

              </v-list>
              </div>
            </v-sheet>
          </v-card>
        </v-col>

        <!-- Conteúdo principal central -->
        <v-col cols="6" sm="6" md="6" class="animated fadeIn">
          <v-card v-show="selectedItem == 0" outlined height="69vh" style="overflow-y: auto;">
            <v-toolbar color="grey lighten-3" dense elevation="0">
              <v-toolbar-title>
                Resumo clínico
              </v-toolbar-title>
            </v-toolbar>
            <v-skeleton-loader v-if="loadResumo" type="article"></v-skeleton-loader>
            <v-card-text v-if="resumoIntro != ''" v-html="resumoIntro" />
            <v-card-text v-if="resumoProntuarios != ''" v-html="resumoProntuarios" />
          </v-card>

          <v-card v-if="selectedItem == 2" outlined>
             <v-card outlined>
                        <v-sheet min-height="70vh" rounded="lg">

                            <v-item-group v-if="!isAddSolicitacao">
                                <v-container>
                                    <v-row>
                                        <v-col v-for="(solicitacao, n) in solicitacoesCards" :key="n" cols="4" md="4">
                                            <v-item v-slot="{ toggle }">
                                                <v-card>
                                                    <v-card flat class="overflow-y-auto" max-height="400" height="200">

                                                        <ol class="rounded-list ml-5 mr-1">
                                                            <li v-for="(item, index) in solicitacao.items" :key="index">
                                                                <a> {{
                                                                    item.nome
                                                                }}</a>
                                                            </li>
                                                        </ol>

                                                    </v-card>
                                                    <v-card-actions>

                                                        <v-spacer />

                                                        <v-btn icon color="accent" @click="editSolicitacao(n, false)">
                                                            <v-icon>edit</v-icon>
                                                        </v-btn>
                                                        <v-btn icon @click="solicitacoesCards.splice(n, 1)">
                                                            <v-icon>delete</v-icon>
                                                        </v-btn>
                                                    </v-card-actions>
                                                    <v-divider v-show="solicitacao.isObs"></v-divider>
                                                    <v-textarea v-show="solicitacao.isObs"
                                                        v-model="solicitacao.observacao" class="mx-2 mt-2"
                                                        background-color="amber lighten-5" color="orange-darken-5"
                                                        label="Observação" auto-grow />
                                                </v-card>
                                            </v-item>
                                        </v-col>
                                        <v-col v-for="(solicitacao, n) in solicitacoesLaboratorioCards" :key="n"
                                            cols="4" md="4">
                                            <v-item v-slot="{ toggle }">
                                                <v-card>
                                                    <v-card flat class="overflow-y-auto" max-height="400" height="200">

                                                        <ol class="rounded-list ml-5 mr-1">
                                                            <li v-for="(item, index) in solicitacao.items" :key="index">
                                                                <a> {{
                                                                    item.nome
                                                                }}</a>
                                                            </li>
                                                        </ol>

                                                    </v-card>
                                                    <v-card-actions>

                                                        <v-spacer />
                                                        <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn icon color="primary"
                                                                        @click="imprimirSolicitacao(solicitacao.items, solicitacao.observacao, 'LABORATORIO', solicitacao.data)">
                                                                        <v-icon>print</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Abrir opções de impressão da solicitação.</div>
                                                                <v-btn text small color="primary" @click="hintImprimirSolicitacao= true">Saiba mais</v-btn>
                                                            </v-card>
                                                        </v-menu>

                                                        <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn icon color="accent" @click="editSolicitacao(n, true)">
                                                                        <v-icon>edit</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Editar solicitação.</div>
                                                                <v-btn text small color="primary" @click="hintEditarSolicitacao= true">Saiba mais</v-btn>
                                                            </v-card>
                                                        </v-menu>

                                                        <v-menu
                                                            :close-on-content-click="false"
                                                            offset-y
                                                            open-on-hover
                                                            dark
                                                            open-delay="0"
                                                            close-delay="80"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn icon @click="solicitacoesLaboratorioCards.splice(n, 1)">
                                                                        <v-icon>delete</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <v-card color="black" class="pa-2" min-width="250" style="opacity: 0.6; vertical-align: center;">
                                                                <div style="font-size: 14px;">Excluir solicitação.</div>
                                                                <v-btn text small color="primary" @click="hintExcluirSolicitacao= true">Saiba mais</v-btn>
                                                            </v-card>
                                                        </v-menu>

                                                    </v-card-actions>
                                                    <v-divider v-show="solicitacao.isObs"></v-divider>
                                                    <v-textarea v-show="solicitacao.isObs"
                                                        v-model="solicitacao.observacao" class="mx-2 mt-2"
                                                        background-color="amber lighten-5" color="orange-darken-5"
                                                        label="Observação" auto-grow />
                                                </v-card>
                                            </v-item>
                                        </v-col>
                                        <v-col cols="4" md="4">
                                            <v-item v-slot="{ toggle }">
                                                <v-card color="grey lighten-4" class="d-flex align-center" height="250"
                                                    width="250" @click="toggle, isAddSolicitacao = true">
                                                    <v-scroll-y-transition>
                                                        <div
                                                            class="text-h1 flex-grow-1 text-center compleA--text text--lighten-3">
                                                            <v-icon x-large :color="items[mItem].color">add</v-icon>
                                                        </div>
                                                    </v-scroll-y-transition>
                                                </v-card>
                                            </v-item>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-item-group>
                            <div class="pa-2">
                                <solicitacao v-if="isAddSolicitacao" @cancelar="resetarFormularioEdicao"
                                    @solicitacoesLabCard="adicionarSolicitacaoLaboratorio"
                                    @solicitacoesCard="adcionarSolicitacao"
                                    @editarSolicitacaoLabCard="editarSolicitacaoLaboratorio"
                                    @editarSolicitacaoCard="editarSolicitacao" :mExames="examesEdit" :isLabAux="isLab"
                                    :paciente="usuarioSelecionado" :isEditSolicitacao="isEditSolicitacao">
                                </solicitacao>

                                <!-- <receita v-if="isAddReceita" v-on:addReceita="adcionarReceita" v-on:cancelar="isAddReceita = false"></receita> -->
                            </div>
                        </v-sheet>
                    </v-card>

                    <!--Hints Solicitação-->
                    <v-dialog v-model="hintIncluirObservacoes" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                 Incluir observações na solicitação.
                            <v-spacer/>
                            <v-btn icon @click="hintIncluirObservacoes = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Permite adicionar uma <b>observação complementar na solicitação de exames</b>, que será impressa junto do pedido. Útil para orientações adicionais ou detalhes importantes ao laboratório ou setor responsável.
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="hintEditarSolicitacao" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Alterar solicitação.
                            <v-spacer/>
                            <v-btn icon @click="hintEditarSolicitacao = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Abre uma solicitação de exame já lançada para <b>ajustar, alterar ou complementar informações antes da impressão ou envio</b>, mantendo o documento atualizado.
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="hintImprimirSolicitacao" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Abrir opções de impressão da solicitação.
                            <v-spacer/>
                            <v-btn icon @click="hintImprimirSolicitacao = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Abre a interface para <b>visualizar, gerar PDF, imprimir ou enviar online a solicitação de exames</b>, garantindo controle sobre o envio e o documento final.
                            </v-card-text>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="hintExcluirSolicitacao" max-width="500px" >
                        <v-card style="overflow-x:hidden;">
                            <v-toolbar flat dense class="teal pa-0 white--text font-weight-bold">
                                Remover solicitação.
                            <v-spacer/>
                            <v-btn icon @click="hintExcluirSolicitacao = false"><v-icon color="white">mdi-close</v-icon></v-btn>
                            </v-toolbar>
                            <v-card-text class="ma-1">
                                Permite <b>excluir a solicitação de exames que já foi lançada</b>, removendo-a do sistema após confirmação, evitando erros ou duplicidades.
                            </v-card-text>
                        </v-card>
                    </v-dialog>
          </v-card>
          <v-card v-show="selectedItem == 1" outlined>
                    <fichaPaciente :idExamesOS="usuarioSelecionado.idexamesos" @voltar="voltarLaudo()" />
          </v-card>
        </v-col>

        <!-- Painel lateral direito com exames -->
        <v-col cols="3" sm="3" md="3" class="ml-1">
          <v-card outlined>
            <v-sheet class="rounded-lg">
              <v-card flat class="rounded-lg mt-3">
                <v-layout row class="align-center pt-4 justify-center">
                  <v-subheader class="text-h6 grey--text">
                    <v-icon left color="grey">mdi-file-document-multiple</v-icon>
                    Histórico
                  </v-subheader>
                </v-layout>
              <v-divider class="mt-2"/>

              </v-card>

              <!-- Lista de exames -->
              <v-list dense class="pa-2" style="max-height: 70vh; overflow-y: auto;">
                <v-list-item
                  v-for="(exame, index) in examesPaciente"
                  :key="index"
                  class="mb-2 "
                >
                  <v-list-item-content>
                    <v-list-item-title class="text-body-1 font-weight-bold primary--text">
                      <v-icon small color="primary" class="mr-1">mdi-calendar</v-icon>
                      {{ formatarDataExame(exame.data) }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption mt-1">
                      <v-icon x-small class="mr-1">mdi-hospital-building</v-icon>
                      {{ exame.prestador }}
                    </v-list-item-subtitle>

                    <v-list-item-subtitle class="mt-1">
                        <strong v-if="exame.tipo == 'Alterado'" class="red--text text--lighten-1">{{ exame.tipo }}</strong>
                        <strong v-else class="green--text text--lighten-1">{{ exame.tipo }}</strong>
                    </v-list-item-subtitle>

                    <div class="text-body-2 mt-2" v-html="exame.conteudo">
                    </div>

                    <v-divider class="mt-2"/>
                  </v-list-item-content>

                </v-list-item>
                <v-alert
                  v-if="examesPaciente.length === 0"
                  type="info"
                  outlined
                  class="mx-2"
                >
                  <v-icon small left>mdi-information</v-icon>
                  Nenhum exame encontrado.
                </v-alert>
              </v-list>

              <v-divider />
              <div class="pb-2"></div>
            </v-sheet>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="dialogAlerta" max-width="500">
        <v-card>
          <v-card-title class="headline error white--text">
            <v-icon left color="white">mdi-alert</v-icon>
            Atenção
          </v-card-title>

          <v-card-text class="pt-4 text-body-1">
            {{ mensagemAlerta }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialogAlerta = false">
              Entendi
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <br />
    </div>
    </div>
</template>

<script>
import medicoService from '../../services/medico.service'
import fichaPaciente from './fichaPaciente.vue'
import solicitacao from './solicitacao.vue'

import { EventBus } from '../../main'

export default {
  name: 'prontuario',
  props: {
    tempoAtd: {
      type: String,
      default: '00:00:00'
    },
    consultasPaciente: {
      type: Array
    }
  },
  components: {
    fichaPaciente,
    solicitacao
  },
  data () {
    return {
      usuarioSelecionado: null,
      usuarios: [],
      search: '',
      loadingUsuarios: false,
      hintEditarSolicitacao: false,
      hintImprimirSolicitacao: false,
      hintExcluirSolicitacao: false,
      hintIncluirObservacoes: false,
      solicitacoesLaboratorioCards: [],
      isAddSolicitacao: false,
      isEditSolicitacao: false,
      isAddSolicitacaoLaboratorio: false,
      solicitacoesCards: [],
      isEditSolicitacaoLaboratorio: false,
      examesPaciente: [],
      examesEdit: [],
      isLab: false,
      dialogAlerta: false,
      mensagemAlerta: '',
      mItem: 0,
      isAddLaudo: false,
      showPdfViewer: false,
      loadResumo: false,
      isAddReceita: false,
      consultaAux: null,
      user: null,
      examesLaudos: [],
      resumoProntuarios: '',
      resumoIntro: '',
      selectedItem: 0,
      exigeAludo: 0,
      items: [
        {
          'text': 'Resumo Clínico',
          'icon': 'book',
          'id': 0,
          'badge': 0,
          'disabled': false,
          'color': '#00BCD4'
        },
        {
          'text': 'Prontuário',
          'icon': 'post_add',
          'badge': 0,
          'id': 1,
          'disabled': false,
          'color': '#1E88E5'
        },
        {
          'text': 'Solicitação',
          'icon': 'pending_actions',
          'id': 2,
          'badge': this.exigeAludo,
          'disabled': false,
          'color': '#7B68EE'
        }
      ]
    }
  },

  computed: {
    usuariosFiltrados () {
      if (!this.search) return this.usuarios

      const searchTerm = this.search.toLowerCase()
      return this.usuarios.filter(usuario =>
        usuario.paciente.toLowerCase().includes(searchTerm) ||
        (usuario.idos && usuario.idos.toString().includes(searchTerm)) ||
        (usuario.idexamesos && usuario.idexamesos.toString().includes(searchTerm)) ||
        (usuario.empresa_cliente && usuario.empresa_cliente.toLowerCase().includes(searchTerm))
      )
    }
  },

  methods: {

    extrairIdsExames (solicitacoesCards, solicitacoesLaboratoriaisCards) {
      const todosIds = []

      // Função auxiliar para extrair ids de um array de solicitações
      const extrairIdsDoArray = (array) => {
        if (array && array.length > 0) {
          array.forEach(solicitacao => {
            if (solicitacao.items && solicitacao.items.length > 0) {
              solicitacao.items.forEach(item => {
                if (item.idExame) {
                  todosIds.push(item.idExame)
                }
              })
            }
          })
        }
      }

      // Extrair ids de ambos os arrays
      extrairIdsDoArray(solicitacoesCards)
      extrairIdsDoArray(solicitacoesLaboratoriaisCards)

      return todosIds
    },
    liberarBloquearAso (status) {
      if (!status) {
        const examesIds = this.extrairIdsExames(this.solicitacoesCards, this.solicitacoesLaboratorioCards)
        if (examesIds.length > 0) {
          medicoService.medico.lancarPreOrdem(this.usuarioSelecionado.idexamesos, this.user.id, examesIds)
        }
      }
      medicoService.medico.liberarBloquearAso(this.usuarioSelecionado.idexamesos, this.user.id, status).then(r => {
        if (r.status == 200) {
          this.mostrarAlerta('ASO atualizado com sucesso.')
          this.voltarParaLista()
        }
      }).catch(error => {
        console.log('Erro ao atualizar ASO:', error)
        this.mostrarAlerta('Erro ao atualizar ASO.')
      })
    },
    resetarFormularioEdicao () {
      this.isAddSolicitacao = false
      this.isEditSolicitacao = false
      this.examesEdit = []
      this.indexToEdit = null
      this.indexToEditLab = null
    },
    getExamesPacienteOS (idOs) {
      medicoService.medico.getExamesPacienteOS(11335848).then(r => {
        if (r.status == 200) {
          this.examesLaudos = r.data || []
          if (this.examesLaudos.length > 0) {
            this.examesLaudos = this.examesLaudos.filter(exame => {
              return exame.exigeLaudoClinico === 1
            })
          }
        }
      }).catch(error => {
        console.error('Erro ao carregar exames do paciente:', error)
      })
    },
    async carregarUsuarios () {
      this.loadingUsuarios = true
      try {
        const response = await medicoService.medico.getReavaliacao(this.user.id)

        if (response.data && response.data.dados) {
          this.usuarios = response.data.dados.map(paciente => ({
            idos: paciente.idos,
            idexamesos: paciente.idexamesos,
            paciente: paciente.paciente,
            status: paciente.status,
            datalanca: paciente.datalanca,
            empresa_cliente: paciente.empresa_cliente,
            cpf: paciente.cpf || '',
            dataNascimento: paciente.dataNascimento || ''
          }))
        }
      } catch (error) {
        console.error('Erro ao carregar pacientes:', error)
        this.mostrarAlerta('Erro ao carregar lista de pacientes')
      } finally {
        this.loadingUsuarios = false
      }
    },

    adcionarSolicitacao (data) {
      this.isAddSolicitacao = false

      if (data.isLaboratorio) {
        this.solicitacoesLaboratorioCards.push(data)
      } else {
        this.solicitacoesCards.push(data)
      }
    },

    adicionarSolicitacaoLaboratorio (data) {
      this.isAddSolicitacao = false
      this.solicitacoesLaboratorioCards.push(data)
    },

    editarSolicitacao (data) {
      // Substituir o item existente no array regular pelo novo dado.
      this.solicitacoesCards[this.indexToEdit] = data
      this.resetarFormularioEdicao()
    },

    editarSolicitacaoLaboratorio (data) {
      // Substituir o item existente no array de laboratório pelo novo dado.
      this.solicitacoesLaboratorioCards[this.indexToEditLab] = data
      this.resetarFormularioEdicao()
    },

    editSolicitacao (index, isLab) {
      this.isLab = isLab
      this.isAddSolicitacao = true
      this.isEditSolicitacao = true

      if (isLab) {
        // Preparar edição de laboratório.
        this.indexToEditLab = index
        this.examesEdit = [...this.solicitacoesLaboratorioCards[index].items]
      } else {
        // Preparar edição regular.
        this.indexToEdit = index
        this.examesEdit = [...this.solicitacoesCards[index].items]
      }
    },

    selecionarUsuario (usuario) {
      this.usuarioSelecionado = usuario
      this.carregarDadosUsuario(usuario.idexamesos)
      this.carregarHistorio(usuario.idos)
      this.getExamesPacienteOS(usuario.idos)
      EventBus.$emit('showSideBar', false)
      EventBus.$emit('paciente-selecionado', usuario)
    },

    carregarHistorio (idos) {
      medicoService.medico.getLaudosOcupacional(idos).then(r => {
        if (r.status == 200) {
          this.examesPaciente = r.data.dados || []
        }
      }).catch(error => {
        console.error('Erro ao carregar histórico:', error)
      })
    },

    voltarParaLista () {
      EventBus.$emit('showSideBar', true)
      EventBus.$emit('item-exit', false)
      this.usuarioSelecionado = null
      this.search = ''
      this.resumoProntuarios = ''
      this.examesPaciente = []
    },

    async carregarDadosUsuario (idexamesos) {
      try {
        this.retornarResumoProntuario(idexamesos)
        this.retornarInformacoesPacienteOs(this.usuarioSelecionado.idos)
      } catch (error) {
        console.error('Erro ao carregar dados do usuário:', error)
        this.mostrarAlerta('Erro ao carregar dados do paciente')
      }
    },

    retornarInformacoesPacienteOs (idOrdemServico) {
      medicoService.medico.retornarInformacoesPacienteOs(idOrdemServico).then(r => {
        if (r.status == 200) {
          const dadosPaciente = {
            ...r.data,
            nome: this.usuarioSelecionado.paciente
          }
          EventBus.$emit('paciente-selecionado', dadosPaciente)
        }
      }).catch(error => {
        console.error('Erro ao buscar informações do paciente:', error)
      })
    },

    getIniciais (nome) {
      if (!nome) return '??'
      return nome.split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase()
        .substring(0, 2)
    },

    formatarCPF (cpf) {
      if (!cpf) return 'Não informado'
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    },

    calcularIdade (dataNascimento) {
      if (!dataNascimento) return 'N/A'

      const nascimento = new Date(dataNascimento)
      const hoje = new Date()
      let idade = hoje.getFullYear() - nascimento.getFullYear()

      const mesAtual = hoje.getMonth()
      const mesNascimento = nascimento.getMonth()

      if (mesAtual < mesNascimento ||
          (mesAtual === mesNascimento && hoje.getDate() < nascimento.getDate())) {
        idade--
      }

      return idade
    },

    formatarDataExame (data) {
      if (!data) return 'Data não informada'
      return data.split(' ')[0] // Retorna apenas a data (remove a hora)
    },

    getDownloadLink (conteudo) {
      if (!conteudo) return null
      const regex = /href='([^']*)'/
      const match = conteudo.match(regex)
      return match ? match[1] : null
    },

    mostrarAlerta (mensagem) {
      this.mensagemAlerta = mensagem
      this.dialogAlerta = true
    },

    retornarResumoProntuario (idos) {
      this.loadResumo = true

      medicoService.medico.getResumoClinicoOcupacional(idos).then(r => {
        if (r.status == 200) {
          console.log(r.data)
          this.resumoIntro = r.data.intro_html || ``
          this.resumoProntuarios = r.data.instrucoes_html || ``
        }
      }).catch(error => {
        console.error('Erro ao carregar resumo:', error)
      }).finally(() => {
        this.loadResumo = false
      })
    },

    voltarLaudo () {
      this.isAddLaudo = false
      this.consultarInfoExames(this.consultasPaciente)
    },

    async downlodLaudo (idExamesOS) {
      const previewWindow = window.open('', '_blank')

      if (previewWindow) {
        previewWindow.document.write('<html><body style="font-family: Arial, sans-serif; padding: 16px;">Carregando laudo...</body></html>')
        previewWindow.document.close()
      }

      try {
        const r = await medicoService.medico.downloadLaudo(idExamesOS)
        const contentType = r.headers && r.headers['content-type'] ? r.headers['content-type'] : 'application/pdf'

        if (r.status !== 200 || !r.data) {
          throw new Error('Falha ao carregar o laudo.')
        }

        const file = r.data instanceof Blob
          ? r.data
          : new Blob([r.data], { type: contentType })

        if (!file.size) {
          throw new Error('O laudo retornou vazio.')
        }

        const fileType = file.type || contentType || ''
        if (fileType && !fileType.includes('pdf')) {
          throw new Error(`Tipo de arquivo inválido: ${fileType}`)
        }

        const fileURL = URL.createObjectURL(file)

        if (previewWindow) {
          previewWindow.location.replace(fileURL)
          return
        }

        window.open(fileURL, '_blank')
      } catch (error) {
        if (previewWindow && !previewWindow.closed) {
          previewWindow.close()
        }
        throw error
      }
    },

    consultarInfoExames (consultasPaciente) {
      this.exigeAludo = 0
      const idsExames = consultasPaciente.map(consulta => consulta.idExame)

      medicoService.medico.retornarExamesPorId(idsExames).then(r => {
        if (r.status == 200) {
          const exames = r.data

          consultasPaciente.forEach(consulta => {
            const exameEncontrado = exames.find(exame => exame.idExame == consulta.idExame)

            if (exameEncontrado) {
              if (exameEncontrado.exigeLaudoClinico) {
                this.exigeAludo += 1
                this.items.forEach(item => {
                  if (item.id == 7) item.badge = this.exigeAludo
                })
              }

              consulta.exigeLaudoClinico = exameEncontrado.exigeLaudoClinico
              consulta.exigeProntuario = exameEncontrado.exigeProntuario
              consulta.exigeFichaAso = exameEncontrado.exigeFichaAso
              consulta.psicoSocial = exameEncontrado.psicoSocial
              consulta.tipoAPI = exameEncontrado.tipoAPI
              consulta.laudo = ''
              consulta.status = ''

              if (consulta.idexamesos != null) {
                medicoService.medico.buscarLaudoComStatus(consulta.idexamesos).then(r => {
                  if (r.status === 200) {
                    if (r.data.laudoClinico != null) {
                      consulta.laudo = r.data.laudoClinico.descricaoLaudo
                      consulta.statusLaudo = r.data.laudoClinico.status
                    }
                    consulta.statusFormulario = r.data.statusFormulario
                  }
                })
              }
            }
          })

          consultasPaciente.sort((a, b) => {
            const aCumpreCondicao = a.exigeLaudoClinico && a.cor !== 'grey lighten-1'
            const bCumpreCondicao = b.exigeLaudoClinico && b.cor !== 'grey lighten-1'

            if (aCumpreCondicao && !bCumpreCondicao) return -1
            if (!aCumpreCondicao && bCumpreCondicao) return 1
            return 0
          })
        }
      }).catch(error => {
        console.error('Erro ao buscar exames:', error)
      })
    }
  },

  watch: {
    mItem (data) {
      if (data != null) {
        this.selectedItem = data
        if (data == 2) {
          data = 3
        }
        EventBus.$emit('item-selecionado', data)
      } else {
        this.mItem = this.selectedItem
      }
    }
  },

  mounted () {
    this.user = this.$store.getters.usuario
    this.carregarUsuarios()
  }
}
</script>

<style scoped>
.selected-user {
  background-color: #e3f2fd !important;
  border-left: 4px solid #2196f3;
}

.exame-item {
  border-left: 3px solid #2196f3;
  background-color: #fafafa;
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 8px;
}

.exame-item:hover {
  background-color: #f0f8ff;
  transition: background-color 0.3s ease;
}

.rounded-exame a {
  position: relative;
  display: block;
  padding: .4em .4em .4em 2em;
  margin: .5em 0;
  background: #DAF5D5;
  color: #050402;
  text-decoration: none;
  border-radius: .3em;
  transition: all .3s ease-out;
}

.rounded-exame a:hover {
  background: #32CD32;
}

.rounded-exame a:hover:before {
  transform: rotate(360deg);
}

.rounded-exame a:before {
  content: "!";
  position: absolute;
  left: -1.3em;
  top: 50%;
  margin-top: -1.3em;
  background: #32CD32;
  height: 2em;
  width: 2em;
  line-height: 2em;
  border: .3em solid #fff;
  text-align: center;
  font-weight: bold;
  border-radius: 2em;
  color: #fff;
  transition: all .4s ease-out;
}
</style>
